// hooks/useFileLoader.js
import { useState, useEffect } from 'react';
import api from '../Api';
const fileCache = new Map();

export const useFileLoader = (filePath) => {
    const [fileUrl, setFileUrl] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [fileType, setFileType] = useState(null);

    useEffect(() => {
        if (!filePath) {
            setFileUrl(null);
            setFileType(null);
            return;
        }
        if (fileCache.has(filePath)) {
            setFileUrl(fileCache.get(filePath));
            return;
        }

        let isMounted = true;
        let objectUrl = null;

        const loadFile = async () => {
            setLoading(true);
            setError(null);
            
            try {
                // Загружаем файл через api (токен добавится автоматически)
                const response = await api.get(filePath, {
                    responseType: 'blob'
                });
                
                if (isMounted) {
                    // Определяем тип файла
                    const contentType = response.headers['content-type'] || response.data.type;
                    setFileType(contentType);
                    
                    // Создаем временный URL
                    objectUrl = URL.createObjectURL(response.data);
                    fileCache.set(filePath, objectUrl);
                    setFileUrl(objectUrl);
                }
            } catch (err) {
                if (isMounted) {
                    console.error('Failed to load file:', err);
                    setError(err);
                }
            } finally {
                if (isMounted) {
                    setLoading(false);
                }
            }
        };

        loadFile();

        return () => {
            isMounted = false;
            // if (objectUrl) {
            //     URL.revokeObjectURL(objectUrl);
            // }
        };
    }, [filePath]);

    return { fileUrl, loading, error, fileType };
};

export const clearFileCache = () => {
    fileCache.forEach((url) => {
        URL.revokeObjectURL(url);
    });
    fileCache.clear();
};